/* cb-product-card.js — Slider, Lazy-Slides & Merkzettel für snippets/cb-product-card.liquid */
(function(){
if(!window.__cbpcInit){
  window.__cbpcInit=true;

  /* ── Wishlist (localStorage) ── */
  var WL_KEY='cb_wishlist';
  function wlGet(){try{return JSON.parse(localStorage.getItem(WL_KEY))||[];}catch(e){return[];}}
  function wlSet(arr){localStorage.setItem(WL_KEY,JSON.stringify(arr));wlUpdateCount();}
  function wlToggle(id){
    var list=wlGet();
    var idx=list.indexOf(id);
    if(idx>-1){list.splice(idx,1);}else{list.push(id);}
    wlSet(list);
    return idx===-1; // true = added
  }
  function wlHas(id){return wlGet().indexOf(id)>-1;}
  function wlUpdateCount(){
    var count=wlGet().length;
    document.querySelectorAll('.cb-wl-count').forEach(function(el){
      el.textContent=count;
      el.closest('.cb-wl-header-btn').classList.toggle('cb-wl-header-btn--has',count>0);
    });
  }
  // Init: mark active hearts
  function wlInitHearts(){
    document.querySelectorAll('.cbpc__wishlist').forEach(function(btn){
      var id=btn.dataset.productId;
      if(wlHas(id)){
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
    wlUpdateCount();
  }
  wlInitHearts();

  // Heart click
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.cbpc__wishlist');
    if(btn){
      e.preventDefault();
      e.stopPropagation();
      var id=btn.dataset.productId;
      var added=wlToggle(id);
      btn.classList.toggle('is-active',added);
      // Micro animation
      btn.style.transform='scale(1.3)';
      setTimeout(function(){btn.style.transform='';},200);
      return;
    }
  });


  /* ── Slider-Bilder 2–5 erst bei Interaktion laden (Audit #5) ── */
  function cbpcLoadSlides(card){
    if(!card||card.dataset.slidesLoaded)return;
    card.dataset.slidesLoaded='1';
    card.querySelectorAll('img[data-src]').forEach(function(img){
      if(img.dataset.srcset)img.srcset=img.dataset.srcset;
      img.src=img.dataset.src;
      img.removeAttribute('data-src');img.removeAttribute('data-srcset');
    });
  }
  ['pointerenter','touchstart','focusin'].forEach(function(evt){
    document.addEventListener(evt,function(e){
      var t=e.target;
      if(!t||!t.closest)return;
      var slider=t.closest('.cbpc__slider');
      if(slider)cbpcLoadSlides(slider);
    },{passive:true,capture:true});
  });

  /* ── Slider ── */
  function cbpcGoTo(slider,idx){
    cbpcLoadSlides(slider);
    var slides=slider.querySelector('.cbpc__slides');
    var all=slides.querySelectorAll('.cbpc__slide');
    var total=all.length;
    if(idx<0)idx=0;
    if(idx>=total)idx=total-1;
    var w=all[0].offsetWidth;
    slides.scrollTo({left:w*idx,behavior:'smooth'});
  }
  function cbpcCurrent(slider){
    var slides=slider.querySelector('.cbpc__slides');
    var all=slides.querySelectorAll('.cbpc__slide');
    var w=all[0]?all[0].offsetWidth:1;
    return Math.round(slides.scrollLeft/w);
  }
  // Arrow click
  document.addEventListener('click',function(e){
    var arrow=e.target.closest('.cbpc__arrow');
    if(arrow){
      e.preventDefault();
      e.stopPropagation();
      var slider=arrow.closest('.cbpc__slider');
      var cur=cbpcCurrent(slider);
      if(arrow.classList.contains('cbpc__arrow--next')){
        cbpcGoTo(slider,cur+1);
      } else {
        cbpcGoTo(slider,cur-1);
      }
      return;
    }
    // Dot click
    var dot=e.target.closest('.cbpc__dot');
    if(dot){
      e.preventDefault();
      var slider=dot.closest('.cbpc__slider');
      cbpcGoTo(slider,parseInt(dot.dataset.index));
    }
  });
  // IntersectionObserver → update dots
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(!en.isIntersecting)return;
      var slide=en.target;
      var slider=slide.closest('.cbpc__slider');
      if(!slider)return;
      var idx=slide.dataset.index;
      slider.querySelectorAll('.cbpc__dot').forEach(function(d){
        d.classList.toggle('cbpc__dot--active',d.dataset.index===idx);
      });
    });
  },{threshold:0.6});
  function initSlides(){
    document.querySelectorAll('.cbpc__slide').forEach(function(s){
      if(!s.dataset.observed){s.dataset.observed='1';obs.observe(s);}
    });
    wlInitHearts();
  }
  initSlides();
  // Re-init after AJAX pagination und nach dem Filtern. Beim Filtern wird #product-grid komplett ersetzt,
  // deshalb den Container beobachten, der stehen bleibt (sonst blieben gemerkte Herzen leer).
  var mo=new MutationObserver(function(){setTimeout(initSlides,100);});
  var grid=document.getElementById('ProductGridContainer')||document.getElementById('product-grid');
  if(grid)mo.observe(grid,{childList:true,subtree:true});
  document.addEventListener('facets:updated',initSlides);
}
})();
